import { Checkbox, View } from "@/components/ui";
import { Typography } from "../typography";
import { cn } from "@/lib/utils";

type ListCheckboxInputProps = {
  values: string[];
  items: {
    label: string;
    value: string;
    caption?: string;
  }[];
  onChange?: (values: string[]) => void;
  disabled?: boolean;
  onItemChange?: (label: string, checked: boolean) => void;
};

export const ListCheckboxInput = ({
  items,
  values,
  onChange,
  disabled = false,
  onItemChange,
}: ListCheckboxInputProps) => {
  const handleItemChange = (value: string, checked: boolean) => {
    const newValues = checked
      ? [...values, value]
      : values.filter((v) => v !== value);
    onChange?.(newValues);
    onItemChange?.(value, checked);
  };

  return (
    <View className="space-y-2">
      {items.map((item) => (
        <ListCheckboxInputItem
          key={item.value}
          checked={values.includes(item.value)}
          label={item.label}
          caption={item.caption}
          disabled={disabled}
          onChange={handleItemChange}
        />
      ))}
    </View>
  );
};

export const ListCheckboxInputItem = ({
  checked,
  label,
  caption,
  disabled,
  onChange,
  className,
}: {
  checked: boolean;
  label: string;
  caption?: string;
  disabled?: boolean;
  onChange: (label: string, value: boolean) => void;
  className?: string;
}) => {
  return (
    <View
      className={cn("flex flex-row items-center gap-2 self-start", className)}
    >
      <Checkbox
        id={label}
        disabled={disabled}
        checked={checked}
        onCheckedChange={(value) => onChange(label, value)}
      />
      <View className="flex-1 gap-1 border-b border-border-medium py-3">
        <Typography
          htmlFor={label}
          variant="body-sm"
          onClick={() => onChange(label, !checked)}
        >
          {label}
        </Typography>
        {caption && (
          <Typography
            htmlFor={label}
            variant="caption-md"
            fontStyle="italic"
            color="foreground-intermediate"
          >
            {caption}
          </Typography>
        )}
      </View>
    </View>
  );
};
